import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Shuffle } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const AutoRebalanceCard = ({ company, onChange }) => {
  const [busy, setBusy] = useState(false);
  const on = company.auto_rebalance !== false;
  const toggle = async (value) => {
    setBusy(true);
    try {
      const { data } = await api.put("/company/settings", { auto_rebalance: value });
      onChange(data);
      toast.success(value ? "Auto Rebalance turned on" : "Auto Rebalance turned off");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };
  return (
    <div className="card-soft" data-testid="auto-rebalance-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-heading text-xl text-[#1E3F33] flex items-center gap-2"><Shuffle className="w-4 h-4 text-[#CC5A3A]" /> Auto Rebalance</h3>
          <p className="text-sm text-[#5C6B64] mt-1">When a new lead sits uncontacted for 48 hours, we move it to the best-matched teammate (offers the service, covers the area, fewest open leads). It can move again every 48 hours until someone contacts the customer. Both collectors are notified.</p>
          <p className="text-xs text-[#8A9A86] mt-2">A workload summary is emailed to the company at 8 AM Eastern on days with overloaded teammates or leads waiting 48h+.</p>
        </div>
        <Switch checked={on} disabled={busy} onCheckedChange={toggle} data-testid="auto-rebalance-toggle" aria-label="Auto Rebalance" />
      </div>
      <p className={`text-xs font-medium mt-3 ${on ? "text-[#2D6A4F]" : "text-[#8A9A86]"}`} data-testid="auto-rebalance-status">{on ? "On — checked every hour" : "Off — leads stay with their collector"}</p>
    </div>
  );
};
